<template>
<div class="chapter">
<div class="inner_page">
<p class="partno">PART ONE</p>
<p class="parttitle">commonsense</p>
<p class="parttitle1"><i>evidence</i></p>
<div class="figure">
<p class="image"><img alt="" src="images/fig5.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?098aab67